import { useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";
import { Save, Plus, Trash2 } from "lucide-react";

export default function ContentCMS() {
  const [content, setContent] = useState(null);
  const [saved, setSaved] = useState(false);
  const [err, setErr] = useState("");
  const [tab, setTab] = useState("hero");

  useEffect(() => { api.get("/content").then((r) => setContent(r.data)); }, []);

  const save = async () => {
    setErr(""); setSaved(false);
    try {
      await api.put("/admin/content", content);
      setSaved(true); setTimeout(() => setSaved(false), 2500);
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail));
    }
  };

  if (!content) return <div className="p-8 text-[#A8A39D]">...</div>;
  const set = (k, v) => setContent((c) => ({ ...c, [k]: v }));
  const setFaq = (idx, k, v) => setContent((c) => ({ ...c, faq: c.faq.map((f, i) => i === idx ? { ...f, [k]: v } : f) }));
  const addFaq = () => setContent((c) => ({ ...c, faq: [...(c.faq || []), { q_fr: "", a_fr: "", q_en: "", a_en: "" }] }));
  const delFaq = (idx) => setContent((c) => ({ ...c, faq: c.faq.filter((_, i) => i !== idx) }));

  return (
    <div className="p-8 lg:p-12" data-testid="cms-page">
      <div className="overline mb-2">Super Admin · Marketing</div>
      <h1 className="font-serif text-4xl font-light mb-3">Contenu du site</h1>
      <p className="text-[#A8A39D] text-sm mb-8 max-w-2xl">Modifiez les textes de la page d'accueil et la FAQ sans toucher au code. Changements visibles immédiatement.</p>

      <div className="flex flex-wrap gap-2 mb-8 border-b border-white/5 pb-4">
        {[["hero","Page d'accueil"],["cta","Bannière CTA"],["announce","Annonce barre"],["faq","FAQ"]].map(([k,l]) => (
          <button key={k} data-testid={`cms-tab-${k}`} onClick={() => setTab(k)} className={`px-4 py-2 text-xs tracking-[0.2em] uppercase border transition-colors ${tab === k ? "border-[#C5A059] text-[#C5A059] bg-[#C5A059]/5" : "border-white/10 text-[#A8A39D] hover:text-[#F5F0EB]"}`}>{l}</button>
        ))}
      </div>

      {tab === "hero" && (
        <div className="stat-card space-y-5">
          <div className="overline mb-2">Hero — FR</div>
          <div><label className="overline text-xs">Titre principal</label><input data-testid="cms-hero-title-fr" className="luxe-input mt-2" value={content.hero_title_fr || ""} onChange={(e) => set("hero_title_fr", e.target.value)} /></div>
          <div><label className="overline text-xs">Titre accent (or)</label><input data-testid="cms-hero-accent-fr" className="luxe-input mt-2" value={content.hero_title_accent_fr || ""} onChange={(e) => set("hero_title_accent_fr", e.target.value)} /></div>
          <div><label className="overline text-xs">Sous-titre</label><textarea data-testid="cms-hero-sub-fr" rows={3} className="luxe-input mt-2" value={content.hero_sub_fr || ""} onChange={(e) => set("hero_sub_fr", e.target.value)} /></div>
          <div className="overline mb-2 pt-4 border-t border-white/5">Hero — EN</div>
          <div><label className="overline text-xs">Title</label><input data-testid="cms-hero-title-en" className="luxe-input mt-2" value={content.hero_title_en || ""} onChange={(e) => set("hero_title_en", e.target.value)} /></div>
          <div><label className="overline text-xs">Accent</label><input data-testid="cms-hero-accent-en" className="luxe-input mt-2" value={content.hero_title_accent_en || ""} onChange={(e) => set("hero_title_accent_en", e.target.value)} /></div>
          <div><label className="overline text-xs">Subtitle</label><textarea rows={3} className="luxe-input mt-2" value={content.hero_sub_en || ""} onChange={(e) => set("hero_sub_en", e.target.value)} /></div>
          <div className="pt-4 border-t border-white/5"><label className="overline text-xs">Image hero (URL) — laissez vide pour l'image par défaut</label><input data-testid="cms-hero-img" className="luxe-input mt-2" value={content.hero_image_url || ""} onChange={(e) => set("hero_image_url", e.target.value)} placeholder="https://..." /></div>
        </div>
      )}

      {tab === "cta" && (
        <div className="stat-card space-y-5">
          <div className="overline">Bannière CTA (bas de page d'accueil)</div>
          <div><label className="overline text-xs">Titre FR</label><input data-testid="cms-cta-title-fr" className="luxe-input mt-2" value={content.cta_title_fr || ""} onChange={(e) => set("cta_title_fr", e.target.value)} /></div>
          <div><label className="overline text-xs">Sous-titre FR</label><textarea rows={2} className="luxe-input mt-2" value={content.cta_sub_fr || ""} onChange={(e) => set("cta_sub_fr", e.target.value)} /></div>
          <div className="pt-4 border-t border-white/5"><label className="overline text-xs">Title EN</label><input className="luxe-input mt-2" value={content.cta_title_en || ""} onChange={(e) => set("cta_title_en", e.target.value)} /></div>
          <div><label className="overline text-xs">Subtitle EN</label><textarea rows={2} className="luxe-input mt-2" value={content.cta_sub_en || ""} onChange={(e) => set("cta_sub_en", e.target.value)} /></div>
        </div>
      )}

      {tab === "announce" && (
        <div className="stat-card space-y-5">
          <div className="overline">Barre d'annonce en haut du site (laissez vide pour cacher)</div>
          <div><label className="overline text-xs">FR</label><input data-testid="cms-announce-fr" className="luxe-input mt-2" value={content.banner_announce_fr || ""} onChange={(e) => set("banner_announce_fr", e.target.value)} placeholder="Ex : Nouveau : statistiques Premium disponibles 🎉" /></div>
          <div><label className="overline text-xs">EN</label><input className="luxe-input mt-2" value={content.banner_announce_en || ""} onChange={(e) => set("banner_announce_en", e.target.value)} /></div>
        </div>
      )}

      {tab === "faq" && (
        <div className="space-y-3">
          {(content.faq || []).map((f, i) => (
            <div key={i} data-testid={`cms-faq-${i}`} className="stat-card">
              <div className="flex items-center justify-between mb-3">
                <div className="overline text-xs">Question #{i + 1}</div>
                <button data-testid={`cms-del-faq-${i}`} onClick={() => delFaq(i)} className="text-red-400 hover:text-red-300 p-1"><Trash2 size={14} /></button>
              </div>
              <div className="grid sm:grid-cols-2 gap-3">
                <div><label className="overline text-xs">Q (FR)</label><input className="luxe-input mt-2" value={f.q_fr || ""} onChange={(e) => setFaq(i, "q_fr", e.target.value)} /></div>
                <div><label className="overline text-xs">Q (EN)</label><input className="luxe-input mt-2" value={f.q_en || ""} onChange={(e) => setFaq(i, "q_en", e.target.value)} /></div>
                <div><label className="overline text-xs">R (FR)</label><textarea rows={2} className="luxe-input mt-2" value={f.a_fr || ""} onChange={(e) => setFaq(i, "a_fr", e.target.value)} /></div>
                <div><label className="overline text-xs">R (EN)</label><textarea rows={2} className="luxe-input mt-2" value={f.a_en || ""} onChange={(e) => setFaq(i, "a_en", e.target.value)} /></div>
              </div>
            </div>
          ))}
          <button data-testid="cms-add-faq" onClick={addFaq} className="btn-ghost"><Plus size={14} /> Ajouter une question</button>
        </div>
      )}

      {err && <div className="text-red-400 text-sm mt-6">{err}</div>}
      <div className="mt-8 flex items-center gap-4 sticky bottom-4">
        <button data-testid="cms-save" onClick={save} className="btn-gold"><Save size={14} /> Enregistrer</button>
        {saved && <span className="text-[#C5A059] text-xs tracking-widest uppercase">✓ Publié</span>}
      </div>
    </div>
  );
}
